@if (state$ | async; as vm) {
  <kendo-label class="margin-top-8" [text]="label"></kendo-label>
  <kendo-combobox
    data-automation-id="{{ automationId }}"
    [data]="vm.customers"
    textField="name"
    valueField="dcCustomerNumber"
    [value]="vm.selectedCustomer"
    [loading]="vm.isLoading"
    [valuePrimitive]="false"
    [placeholder]="placeholder"
    [filterable]="true"
    (filterChange)="handleFilterCustomer($event)"
    (valueChange)="handleCustomerSelected($event)"
  >
    <ng-template kendoComboBoxItemTemplate let-customer>
      <div
        class="kendo-dropdown-list-item-template"
        [ngStyle]="{
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
        }"
      >
        <div class="item-header">{{ customer?.name }}</div>
        <div
          [ngStyle]="{
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
          }"
          title="{{ customer?.dcCustomerNumber }}"
        >
          {{ customer?.dcCustomerNumber }}
          @if (customer?.isKCDCustomer) {
            <kehe-phoenix-tag variant="connect direct"></kehe-phoenix-tag>
          }
        </div>
      </div>
    </ng-template>
    @if (vm.customers?.length >= longListCount) {
      <ng-template kendoComboBoxFooterTemplate>
        <kendo-formhint class="col-sm-12">
          Search results are limited to {{ longListCount }} items
        </kendo-formhint>
      </ng-template>
    }
  </kendo-combobox>
}
